import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  WarningCircle,
  WhatsappLogo,
  CheckCircle,
  MagnifyingGlass,
  Motorcycle,
} from "@phosphor-icons/react";
import Layout from "../components/Layout";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function RevisionsReportPage() {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await axios.get(`${API}/reports/revisions-due`, {
          withCredentials: true,
        });
        setReport(res.data);
      } catch (err) {
        toast.error("Erro ao carregar relatório de revisões.");
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, []);

  const openWhatsApp = (client, moto) => {
    if (!client.whatsapp && !client.phone) {
      toast.error("Cliente não possui número cadastrado.");
      return;
    }

    let number = (client.whatsapp || client.phone).replace(/\D/g, "");
    if (number.length <= 11) number = `55${number}`;

    const text = moto.is_overdue
      ? `Olá, ${client.name}! Tudo bem? Vimos que a revisão da sua ${moto.model} (Chassi: ${moto.chassis_sn}) está atrasada há ${Math.abs(moto.days_since_service)} dias. Vamos agendar um horário na nossa oficina?`
      : `Olá, ${client.name}! Tudo bem? Faltam apenas ${Math.abs(moto.days_since_service)} dias para a revisão da sua ${moto.model} (Chassi: ${moto.chassis_sn}). Vamos agendar um horário na nossa oficina?`;

    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(text)}`,
      "_blank",
    );
  };

  const filteredReport = report.filter(
    (item) =>
      item.client.name.toLowerCase().includes(search.toLowerCase()) ||
      item.chassis_sn.includes(search.toUpperCase()),
  );

  return (
    <Layout title="Relatório de Revisões">
      <div className="space-y-6 pb-6 animate-fade-in">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold flex items-center gap-2">
              <WarningCircle size={28} className="text-yellow-500" />
              Revisões Programadas
            </h1>
            <p className="text-sm text-[#A1A1AA] mt-1">
              Acompanhamento de motos com revisões vencidas ou próximas da data
              de agendamento.
            </p>
          </div>
        </div>

        <div className="relative w-full">
          <MagnifyingGlass
            size={20}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-[#A1A1AA]"
          />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input-field !pl-12 h-12 w-full"
            placeholder="Buscar por cliente ou chassi..."
          />
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-40">
            <div className="animate-spin w-8 h-8 border-2 border-[#00E676] border-t-transparent rounded-full"></div>
          </div>
        ) : filteredReport.length === 0 ? (
          <div className="card p-8 text-center text-[#A1A1AA]">
            <CheckCircle size={48} className="mx-auto mb-4 text-[#00E676]/50" />
            <p className="text-lg font-medium text-white mb-1">
              {search ? "Nenhum resultado encontrado" : "Tudo em dia!"}
            </p>
            <p className="text-sm">
              {search
                ? `Não encontramos nenhuma moto ou cliente com "${search}".`
                : "Não há nenhuma revisão programada ou atrasada no momento."}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filteredReport.map((item) => (
              <div
                key={item.id}
                className={`card p-4 border-l-4 ${
                  item.is_overdue
                    ? "border-l-red-500 bg-red-500/5"
                    : "border-l-yellow-500 bg-yellow-500/5"
                }`}
              >
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-lg">{item.client.name}</h3>
                    <p className="text-xs text-[#A1A1AA] flex items-center gap-1 mt-1">
                      <Motorcycle size={14} /> {item.model} • {item.chassis_sn}
                    </p>
                  </div>
                  <div className="text-right">
                    <span
                      className={`text-2xl font-bold ${item.is_overdue ? "text-red-500" : "text-yellow-500"}`}
                    >
                      {Math.abs(item.days_since_service)}
                    </span>
                    <p className="text-[10px] text-[#A1A1AA] uppercase font-bold">
                      {item.is_overdue ? "Dias Atrasada" : "Dias Restantes"}
                    </p>
                  </div>
                </div>

                <div className="pt-3 border-t border-white/5 flex gap-2">
                  <button
                    onClick={() => openWhatsApp(item.client, item)}
                    className="flex-1 bg-[#25D366]/10 hover:bg-[#25D366]/20 text-[#25D366] border border-[#25D366]/20 py-2 rounded-lg text-sm font-bold flex justify-center items-center gap-2 transition-colors"
                  >
                    <WhatsappLogo size={18} weight="fill" />
                    Notificar Cliente
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
